import { render, staticRenderFns } from "./StandardFields.vue?vue&type=template&id=1a90d32c&"
import script from "./StandardFields.vue?vue&type=script&lang=js&"
export * from "./StandardFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports